import { useCallback, useState } from "react";
import useWindowDimensions from "./useWindowDimensions";

// calculate the maximum allowed height of the media/credit list
const useListHeight = () => {
	const { height } = useWindowDimensions();
	const [listHeight, setListHeight] = useState(300);

	const usedHeight = useCallback(
		(node: HTMLElement | null) => {
			if (!node) return;

			const parent = node.parentNode as HTMLElement;
			if (!parent) return;

			const resizeObserver = new ResizeObserver(() => {
				const container = parent.getBoundingClientRect();
				const pt = getComputedStyle(parent).paddingTop.replaceAll("px", "");
				const pb = getComputedStyle(parent).paddingTop.replaceAll("px", "");
				const containerHeight = container.height - Number(pt) - Number(pb);

				// the area containing the "multiselect" text and sort dropdown
				const area = node.getBoundingClientRect().height;

				if (!isNaN(containerHeight) || !isNaN(area)) {
					setListHeight(containerHeight - area);
				}
			});

			resizeObserver.observe(node);
		},
		[height],
	);

	return { usedHeight, listHeight };
};

export default useListHeight;
